
angular.module('bmsApp.directives').controller('PhotoViewModalCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'$modalInstance',
	'$ngBootbox',
	'title',
	'photo',
	function (
		$scope,
		$q,
		$timeout,
		$modalInstance,
		$ngBootbox,
		title,
		photo
		) {

		$scope.loading = true;
		$scope.photo = photo;
		$scope.title = title;

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};
		
	}]);
